import React from 'react';
import Filter, { FilterModal, FilterSection } from './Filter';
import PrizeMoneyRangeFilter from './FilterComponents/PrizeMoneyRangeFilter';
import UtrFilterComponent from './FilterComponents/UtrFilterComponent';
import CheckboxFilterByType from './FilterComponents/CheckboxFilterByType';

import styles from '../search.scss';
import { ratingTypes } from '../../../utils/constants';

const EventsUtrFilter = (props) => {
    const { filters, filterInputs, handleFilterClick, filterModal, closeModals, handleFilterSubmit, clearFilters, searchTypes, handleFilterUpdate, mobileOnly, desktopOnly, 'data-testid': dataTestId } = props;
    const eventsUtrFilterAreActive = filters && (filters.utrMin > 1 || filters.utrMax < 16 || filters.utrType || filters.utrTeamType || filters.prizeMoneyMin > 1 || filters.prizeMoneyMax < searchTypes.prizeMoneyValues.length);

    return (
        <div className={styles.filterWrapper}>
            <Filter
                filterName={'eventsUtrFilter'}
                handleFilterClick={handleFilterClick}
                isActive={eventsUtrFilterAreActive || filterModal === 'eventsUtrFilter'}
                mobileOnly={mobileOnly}
                desktopOnly={desktopOnly}
                data-testid={dataTestId}
            >
                {ratingTypes.tennis}
            </Filter>
            {filterModal === 'eventsUtrFilter' && (
                <FilterModal
                    title={'More...'}
                    onCloseClick={closeModals}
                    clearFilters={() => clearFilters('eventsUtrFilter', true)}
                    scrollable={true}
                    handleFilterSubmit={handleFilterSubmit}
                    data-testid={dataTestId}
                >
                    <FilterSection data-testid={dataTestId && `${dataTestId}.body`}>
                        <React.Fragment>
                            <div className={styles.searchFilterModalTitle} data-testid={dataTestId && `${dataTestId}.verified-event-title`}>Verified Event</div>
                            <CheckboxFilterByType
                                searchTypes={searchTypes}
                                searchTypesPropName={`utrType`}
                                filterInputs={filterInputs}
                                filtersPropName={`eventUtrTypes`}
                                onChange={(value) => {
                                    handleFilterUpdate({
                                        eventUtrTypes: {
                                            ...filterInputs.eventUtrTypes,
                                            [value]: !filterInputs.eventUtrTypes[value],
                                        },
                                    });
                                }}
                                data-testid={dataTestId && `${dataTestId}.utr-type-options`}
                            />

                            <div className={styles.searchFilterModalDiv} />
                            <PrizeMoneyRangeFilter
                                filterInputs={filterInputs}
                                searchTypes={searchTypes}
                                handlePrizeMoneyChange={(range) => {
                                    handleFilterUpdate({
                                        prizeMoneyMin: range[0],
                                        prizeMoneyMax: range[1],
                                    });
                                }}
                                data-testid={dataTestId && `${dataTestId}.prize-money-range`}
                            />

                            <div className={`${styles.searchFilterModalDiv} mt16`} />
                            <UtrFilterComponent
                                filterInputs={props.filterInputs}
                                filters={filters}
                                showExpandedUtrFilter={false}
                                handleUTRChange={(range) => {
                                    handleFilterUpdate({
                                        utrMin: range[0],
                                        utrMax: range[1],
                                    });
                                }}
                                handleUtrTypeClick={(utrType) => {
                                    handleFilterUpdate({ utrType });
                                }}
                                handleUtrTeamTypeClick={(utrTeamType) => {
                                    handleFilterUpdate({ utrTeamType });
                                }}
                                handleUtrReliabilityClick={(utrReliability) => {
                                    handleFilterUpdate({ utrReliability });
                                }}
                                data-testid={dataTestId && `${dataTestId}.utr-filter`}
                            />

                            <div className={styles.searchFilterModalDiv} />
                            <div className={styles.searchFilterModalTitle} data-testid={dataTestId && `${dataTestId}.team-type-title`}>Team Type</div>
                            <CheckboxFilterByType
                                searchTypes={searchTypes}
                                searchTypesPropName={`eventTeamTypes`}
                                filterInputs={filterInputs}
                                filtersPropName={`eventTeamTypes`}
                                onChange={(value) => {
                                    handleFilterUpdate({
                                        eventTeamTypes: {
                                            ...filterInputs.eventTeamTypes,
                                            [value]: !filterInputs.eventTeamTypes[value],
                                        },
                                    });
                                }}
                                data-testid={dataTestId && `${dataTestId}.team-type-options`}
                            />
                        </React.Fragment>
                    </FilterSection>
                </FilterModal>
            )}
        </div>
    );
};

export default EventsUtrFilter;
